import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import Desktop from 'screen/desktop';
import Gate from "./screen/gate";
import { AUTH_REQUIRED_EVENT } from 'service/apiClient';

function AuthRedirectListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const onAuthRequired = () => navigate('/gate');
    window.addEventListener(AUTH_REQUIRED_EVENT, onAuthRequired);
    return () => window.removeEventListener(AUTH_REQUIRED_EVENT, onAuthRequired);
  }, [navigate]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthRedirectListener />
      <Routes>
        <Route path="/" element={<Desktop />} />
        <Route path="/gate" element={<Gate />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
